import script from "./DevControls.vue?vue&type=script&lang=js"
export * from "./DevControls.vue?vue&type=script&lang=js"

import "./DevControls.vue?vue&type=style&index=0&id=7d442958&lang=scss"

const __exports__ = script;

export default __exports__